import Jobposting from "./Jobposting";

export const constants = {
    headerPage: {
        menu1: `HOME`,
        menu2: `Product`,
        submenu1: `SPORTS`,
        submenu2: `AGRI`,
        submenu3: `OCR`,
        menu3: `Services`,
        submenu4: `CONSULTING`,
        submenu5: `BOOTCAMP`,
        submenu6: `HIRE & MANAGE`,
        submenu7: `TRAINING`,
        menu4: `About Us`,
        submenu8: `ABOUT COMPANY`,
        submenu9: `INSIGHTS`,
        menu5: `Careers`,
        submenu10: `PAGE TO SUPPORT`,
        submenu11: `JOB POSTING`,
        menu6: `Contact Us`,
        submenu12: `CONTACT PAGE`
    },
    bannerPage:{
        bannerTitle1: `Hello Customer`,
        bannerTitle2: `Welcome to best workshop's platform`,
        bannerDescription: `This is a responsive website for a user-friendly`,
        bannerButtonName: `Join Us Now!`
    },
    servicesCard: {
        card1Title: `Best Services`,
        card1Description: `Suspendisse tempor mauris a sem elementum bibendum`,
        card2Title: `Best Mentors`,
        card2Description: `Suspendisse tempor mauris a sem elementum bibendum. Praesent facilisis massa non vestibulum. Suspendisse tempor mauris a sem elementum bibendumSuspendisse tempor mauris a sem elementum bibendum Suspendisse tempor mauris a sem elementum bibendumSuspendisse tempor mauris a sem elementum bibendumSuspendisse tempor mauris a sem elementum bibendumSuspendisse tempor mauris a sem elementum bibendumSuspendisse tempor mauris a sem elementum bibendum`,
        card3Title: `Best Authors`,
        card3Description: `Suspendisse tempor mauris a sem elementum bibendum. Praesent facilisis massa non vestibulum.`,
        card4Title: `Meeting Schedules`,
        card4Description: `Suspendisse tempor mauris a sem elementum bibendum. Praesent facilisis massa non vestibulum.`,
        card5Title: `Best Networking`,
        card5Description: `Suspendisse tempor mauris a sem elementum bibendum. Praesent facilisis massa non vestibulum.`
    },
    sportsPage: {
        title1: `Sports`,
        subTitle1: `Cricket`,
        subTitle2: `Badminton`,
        subTitle3: `Kabadi`
    },
    ocrPage: {
        title1: `CCTV Monitoring`,
        description1: `Inside campus for registered vehicle entry`,
        title2: `Medical data`,
        description2: `Get MRI and CT data`, 
    },
    consultingPage: {
        title1: `Pay as you go(Specifically simple contract based jobs)`,
        description1: `Employee verification`,
        description2: `Invoice for your service (Helpful for filing taxes)`,
        description3: `Quick and easy contract`,
        description4: `Ideal for one time solution`,
        title2: `For Overseas Companies to establish a team in India`,
        description2_1: `Help to make your own team in India`, 
        description2_2: `We provide dedicated HR for your employees`,
        description2_3: `Employee verification and seamless onboarding with Contract and NDA preparation.`,
        description2_4: `Attendance and timesheet maintenance for employees`,
        description2_5: `GPS based attendance`,
        description2_6: `Payroll - Salary + Allowance + PF filing and professional tax filing`,
        description2_7: `Insurance plans if your like to provide your employee (Based on plan and per hire)`,
        description2_8: `Talent acquisition on request (Charged per Hire)`,
        description2_9: `Work equipment purchase for your employees`,
        description2_10: `Establish a new office space for your employees (With additional cost  for space rent and other contract fees)`,
        description2_11: `Arrange a co working spaces for your employees (With additional cost per employee)`,
        description2_12: `Monthly budgeting for your spending and account`,
        title3: `For Companies with Service PartnerShip`,
        subtitle3_1: `We take care of all your establishment`,
        subtitle3_2: `Inclusive of End to End Services`,
        description3_1: `Talent Acquisition`,
        description3_2: `Legal Lawyer for the firm`,
        description3_3: `Registration of Business , trade mark and all other license`,
        description3_4: `Renting and contract of business place or office place`,
        description3_5: `Compliance`,
        description3_6: `Facility Service`,
        description3_7: `Budgeting`,
        description3_8: `Procurement of equipments`,
        description3_9: `Payroll solutions`
    },
    bootCampPage: {
        title1: `Boot Camp`,
        description1: `Python :: Beginner to Programmer`,
        description2: `Machine learning in Python`,
        description3: `Deep learning with Python`,
        description4: `Computer vision with Python`,
        description5: `Automation Testing`
    },
    hiringAndManagePage: {
        title1: `Internships`,
        description1: `Industry experience (With Stipend from Company)`,
        description2: `Final year project  (Chargeable)`,
        subDescription1: `With Research Paper`,
        subDescription2: `Without Research Paper`
    },

    Jobposting: [
        {
            title: 'Frontend Developer',
            description: 'Develop dynamic web applications using React.js. Collaborate with designers and backend developers to create seamless user experiences.'
        },
        {
            title: 'Backend Developer',
            description: 'Build and maintain scalable RESTful APIs using Spring Boot. Work with MySQL and MongoDB to manage data effectively.'
        },
        {
            title: 'Full Stack Developer',
            description: 'Develop end-to-end web applications using the MERN stack. Handle both frontend interfaces and backend logic efficiently.'
        }
    ],
    Jobpost:{
        title:'Job Post',
        btnSubmitText: 'Submit',
        descriptionText: 'Description',
        attachCvText: 'Attach Resume',
        emailText: 'Email'
        
    },
    
    trainingPage: {
        title1: `Courses`,
        description1: `Python :: Beginner to Programmer`,
        description2: `Machine learning in Python`,
        description3: `Deep learning with Python`,
        description4: `Computer vision with Python`,
        description5: `Automation Testing`
    },
    footerPage: {
        title1: `Let's get in touch`,
        buttonName: `SEND MESSAGE NOW`,
        phoneNumberLabel: `Phone Number`,
        phoneNumber: `123-456-7890`,
        emailAddressLabel: `Email Address`,
        emailAddress: `info@flowgrad.com`,
        AddressLine1: `Street Address`,
        AddressLine2: `Address line 1, line 2`,
        webSiteLabel: `Website URL`,
        webSite: `https://flowgrad.com/`,
        copyrightLabel1: `Copyright © 2024 `,
        copyrightLabel2:`Flowgrad Co.,`,
        copyrightLabel3: ` Ltd. All Rights Reserved.`

    }
    
  };